module.exports = __webpack_public_path__ + "static/media/present-box-2.49c6343d.webp";